import { getChainContracts } from "@/shared/config/blockchain/helpers";
import { useWeb3State } from "@/web3/context";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import useCollectionContract from "../../Collection/useCollectionContract";

export default function useApprovalPrefetch(nftContract: string | undefined) {
  const { currentAddress, chainId } = useWeb3State();

  const collectionContract = useCollectionContract(nftContract);

  const getIsApproved = async () => {
    if (!collectionContract) {
      return false;
    }

    const contracts = getChainContracts(chainId);

    return await collectionContract!.isApprovedForAll(
      currentAddress,
      contracts!.exchangeAddress,
    );
  };

  const { data: isApproved, isLoading } = useQuery({
    queryKey: [
      "order-isApproved",
      currentAddress,
      nftContract,
      collectionContract,
    ],
    queryFn: getIsApproved,
  });

  return useMemo(() => ({ isApproved, isLoading }), [isApproved, isLoading]);
}
